<div class="reservation-detail-map">
  <div #googleMap class="googleMap" [ngStyle]="{ height: height }"></div>
  <div class="map-actions">
    <mat-card appearance="outlined" class="route-selector" *ngIf="showRouteLayersContainer">
      <div class="polylines-selectors">
        <mat-checkbox *ngIf="routePolyline" [checked]="routePolyline.getVisible()" (change)="toggleEstimate()" class="estimate">
          Estimate
        </mat-checkbox>
        <mat-checkbox *ngIf="enRoutePolyline" [checked]="enRoutePolyline.getVisible()" (change)="toggleEnRoute()" class="en-route">
          En Route
        </mat-checkbox>
        <mat-checkbox
          *ngIf="completedRoutePolyline"
          [checked]="completedRoutePolyline.getVisible()"
          (change)="toggleCompleted()"
          class="actual"
        >
          Actual
        </mat-checkbox>
      </div>
    </mat-card>
    <mat-card appearance="outlined" id="toggles">
      <button mat-fab (click)="showRouteLayersContainer = !showRouteLayersContainer">
        <mat-icon> layers </mat-icon>
      </button>
      <ng-container *appRequiresPermissions="{ any: ['fare_review'], all: [] }">
        <ng-container *ngIf="rideRequestDetail">
          <button mat-fab (click)="handleShowPredictedRoute()">
            <mat-icon> directions </mat-icon>
          </button>
        </ng-container>
      </ng-container>
      <mat-slide-toggle (change)="toggleTraffic($event)"><mat-icon>directions_car</mat-icon></mat-slide-toggle>
    </mat-card>
  </div>
</div>
